export default __webpack_public_path__ + "static/media/Waterpump.256.73d059bd.png";